"use client" // Error components must be Client components
import React, { useEffect } from "react"

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  return (
    <div className="p-4 stack gap-4 items-start">
      <h2>oopsie</h2>
      <button
        className="link"
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        try again
      </button>
    </div>
  )
}
